import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M20.0986 9.8859c-.3244-.3244-.8219-.3244-1.1463 0s-.3244.8219 0 1.1463c2.271 2.2926 2.271 6.0127-.0216 8.3054-.1514.1514-.238.3676-.238.5839s.0866.411.238.584c.3244.3244.8218.3244 1.1463 0 2.9415-2.9415 2.9415-7.6998.0216-10.6196"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M17.8925 12.092c-.3244-.3245-.8219-.3245-1.1463 0s-.3244.8218 0 1.1463c1.0814 1.0814 1.0814 2.8333 0 3.8931-.1514.1514-.2379.3677-.2379.584s.0865.4109.2379.5839c.3244.3245.8219.3245 1.1463 0 1.7087-1.7302 1.7087-4.4987 0-6.2073m-4.3473-3.1148-4.131 2.8982v.2812c0 2.1196-1.8169 3.8066-4.196 3.958v1.0815c0 .5407.4542.9949.995.9949h2.79l4.542 3.1794c.6705.4758 1.5789 0 1.5789-.8219V9.7991c0-.8003-.9084-1.276-1.5789-.8219"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M7.9217 12.1782V4.6299c.3028.0432.6056.1081.8868.173.5624.1514 1.0814.3677 1.3626.6705.1514.1514.2379.3028.2812.4974.0432.1947.0216.411-.0433.6705-.1298.4975-.4326 1.0165-.8002 1.514-.173.238-.1298.584.0865.7786.2379.2163.6056.173.8219-.0648.4542-.5191.8867-1.1031 1.1463-1.8601.1297-.3677.2163-.8003.1514-1.2545s-.2596-.9084-.5624-1.2328c-.5839-.6705-1.2977-.9949-1.9898-1.2328-.4542-.1514-.9084-.2595-1.3842-.346-.0433-.4543-.411-.8003-.8652-.8003-.4758 0-.8651.3893-.8651.8651v6.9211a3.88 3.88 0 0 0-1.341-.2379c-1.7302 0-3.0928 1.0815-3.0928 2.4873s1.3626 2.4873 3.0928 2.4873 3.1145-1.1031 3.1145-2.4873"
    }, "2")
], "Audio", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
